<template>
  <div class="terms">
    <SanitasTerms
      :back-link="backLink"
      :content-base-url="contentBaseUrl"
      :language="language"
    />
  </div>
</template>
<script>
import { provideI36n } from '@jota-one/i36n/src/index.vue2'
import SanitasTerms, { loadLabels } from 'sanitas-terms-vue2'

export default {
  name: 'Terms',

  components: {
    SanitasTerms,
  },

  props: {
    backLink: {
      type: String,
      required: true,
    },
    contentBaseUrl: {
      type: String,
      required: true,
    },
    language: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    // you need to provide the terms translation in the wrapper
    // component.
    provideI36n(props.language, { load: loadLabels })
  },
}
</script>
